import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DOMParserService } from './parser';
import { CKEditorService } from './service';

@Component({
  standalone: true,
  selector: 'app-ckeditor',
  template: ` <div id="editor"></div> `,
  imports: [CKEditorModule],
  providers: [CKEditorService, DOMParserService],
})
export class CKEditorComponent implements OnInit {
  @Input() lang: string = '';
  @Input() isdisabled: string = '';
  @Output() datafromeditor = new EventEmitter<any>();
  @Output() ckeditorisready = new EventEmitter<any>();

  get isDisabled(): boolean {
    return this.isdisabled === 'True' ? true : false;
  }

  constructor(private ckeditorService: CKEditorService) {}

  ngOnInit() {
    console.log('ckeditor init');
    this.ckeditorService.config.language = this.lang;
    this.ckeditorService.init(this.isDisabled, this.ckeditorisready);
  }

  @HostListener('document:getDataFromCKEditor')
  getData() {
    this.ckeditorService.getData(this.datafromeditor);
  }

  @HostListener('document:setDataToCKEditor', ['$event'])
  setData(event: any) {
    this.ckeditorService.setData(event.detail);
  }
}
